<template>
  <div>
    <h3 class="header-title">Learning</h3>
    <label>Let’s see your tuition subject.</label>
    <br />
    <label
      >
      You have subscribed to the {{ user.packageName }} package, which is valid until  {{ user.validTo }}. This subscription comes at a price of {{ user.currencyCode}}  {{ user.invoiceprice }} and 
      includes a limit of {{ check.NumberOfStudent }} students and <span v-if="check.TotalTeacher === 0">Unlimited</span><span v-else>{{ check.TotalTeacher }} </span> teachers.
      
      </label
    >
    <br />
    <div class="custom-explore">
      <div>
        <CRow>
          <CCol sm="12">
            <div style="width: 80%" class="float-left">
              <img
                src="../assets/img/iconnoti.svg"
                class="ml-5 mr-2 mb-3 mt-3"
              />
              <span class="text-white mt-3 mb-2"> | </span>
              <label class="ml-2 text-white mt-3 mb-2"
                >Explore more on your subject!</label
              >
            </div>
            <div style="width: 20%" class="float-right p-0">
              <br /><br />
              <img
                src="../assets/img/icontriangle.svg"
                class="ml-5 mr-2"
                style="
                  position: absolute;
                  top: 0;
                  right: 100px;
                  bottom: 0;
                  height: 55px;
                "
              />
            </div>
          </CCol>
        </CRow>
      </div>
    </div>
    <div v-if="user.validTo < currentDate" class="mt-2">
      <CAlert show color="danger">
        <CRow>
          <CCol sm="10">
            <strong class="text-danger mr-2"
          >X ERROR ! Your subscription package has expired. Please renew your
          current subscription or upgrade to a new package.
        </strong>
          </CCol>
          <CCol sm="2" class="text-right">
            <CButton type="button" class="custom-btn-navy" @click="GoToRenew()">Renew</CButton>
          </CCol>

        </CRow>
       
      </CAlert>
    </div>
    <div v-if="Busy == true">
      <CCol sm="12" md="12">
        <div class="app flex-row align-items-center">
          <div class="container d-flex justify-content-center">
            <PulseLoader float />
          </div>
        </div>
      </CCol>
    </div>
    <div v-else>
      <CCol sm="12" class="mt-4">
        <CRow>
          <!-- search -->
          <CCol sm="12">
            <CRow>
              <CCol sm="3">
                <CInput
                  type="text"
                  placeholder="Search...."
                  v-model.lazy="SearchQuery"
                />
              </CCol>
            </CRow>
          </CCol>
          <!-- filter grade -->
          <CCol sm="3">
            <v-select
              v-model="selectedGrade"
              :options="gradeOptions"
              label="Grade"
              class="custom-btn-blue style-chooser"
              @input="FilteredData()"
            ></v-select>
          </CCol>
          <!-- filter class -->
          <CCol sm="3">
            <v-select
              v-model="selectedClass"
              :options="classOptions"
              label="Class"
              class="custom-btn-blue style-chooser"
              @input="FilteredData()"
            ></v-select>
          </CCol>
          <!-- add subject & grade -->
          <CCol sm="6">
            <div style="float: right">
              <CButton
                class="custom-btn-success ml-2"
                type="button"
                @click="OpenFormSubject()"
                ><CIcon name="cil-plus" />Add Subject</CButton
              >
              <CButton
                class="custom-btn-lgt ml-2"
                type="button"
                @click="OpenFormGrade()"
                ><CIcon name="cil-plus" />Add Grade & Class</CButton
              >
            </div>
          </CCol>
        </CRow>
      </CCol>

      <!-- not sure -->
      <CCol sm="12">
        <div v-if="FormSchedule == true">
          <br />
          <CCard class="p-3">
            <CCol sm="12">
              <CRow>
                <CCol sm="8"
                  ><h6>Add New Schedule</h6>
                  <label class="small text-muted"
                    >To add new schedule for your Tuition Center</label
                  ></CCol
                >
                <CCol sm="4">
                  <div style="float: right">
                    <CButton
                      type="button"
                      class="btn btn-success custom-btn-light"
                      @click="CreateSchedule(subjectsSchedule.ID)"
                    >
                      Save Schedule</CButton
                    ><CButton
                      type="button"
                      class="btn custom-btn-light ml-1"
                      @click="CloseAddSchedule()"
                      >X Close Form</CButton
                    >
                  </div></CCol
                >
              </CRow>
            </CCol>
            <div style="clear: both"></div>
            <hr />
            <h5>{{ subjectsSchedule.SubjectName }}</h5>
            Grade: {{ subjectsSchedule.Grade }} <br />
            ClassName {{ subjectsSchedule.ClassName }}
            <hr />
            <CRow>
              <CCol sm="4">
                Start Date
                <CInput type="date" v-model="StartDate" />
              </CCol>
              <CCol sm="4">
                End Date
                <CInput type="date" v-model="EndDate" />
              </CCol>
              <CCol sm="4">
                Day
                <v-select
                  v-model="selectedDay"
                  :options="options"
                  placeholder="--Please Select Day--"
                  class="custom-dropdown"
                  label="dayName"
                ></v-select>
              </CCol>
              <CCol sm="4">
                Start Time
                <CInput type="datetime-local" v-model="ScheduleTime" />
              </CCol>
              <CCol sm="4">
                End Time
                <CInput type="datetime-local" v-model="ScheduleTimeEnd" />
              </CCol>
              <CCol sm="4"> </CCol>
            </CRow>
            <CCol sm="12">
              <CRow>
                <CCol sm="8"
                  ><h6 class="mt-3">Update & Delete Schedule</h6>
                  <label class="small text-muted"
                    >To update or delete schedule for your Tuition Center</label
                  ></CCol
                >
                <CCol sm="4"> </CCol>
              </CRow>
            </CCol>
            <div style="clear: both"></div>
            <hr />
            <div class="table-container">
            <table class="table table-responsive-sm table-bordered">
              <thead>
                <th>StartDate</th>
                <th>EndDate</th>
                <th>Day</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th></th>
              </thead>
              <tbody>
                <tr v-if="EditSchedule == true">
                  <td>
                    <CInput type="date" v-model="StartDate" />
                  </td>
                  <td>
                    <CInput type="date" v-model="EndDate" />
                  </td>
                  <td>
                    <v-select
                      v-model="selectedDay"
                      :options="options"
                      placeholder="--Please Select Day--"
                      class="custom-dropdown"
                      label="dayName"
                    ></v-select>
                  </td>
                  <td>
                    <CInput type="datetime-local" v-model="ScheduleTime" />
                  </td>
                  <td>
                    <CInput type="datetime-local" v-model="ScheduleTimeEnd" />
                  </td>
                </tr>
                <tr v-for="item in weeklySchedule" v-bind:key="item.Id">
                  <td>{{ item.StartDate | moment("DD/MM/YYYY") }}</td>
                  <td>{{ item.EndDate | moment("DD/MM/YYYY") }}</td>
                  <td>{{ item.ScheduleDay }}</td>
                  <td>{{ item.ScheduleTime }}</td>
                  <td>{{ item.ScheduleTimeEnd }}</td>
                  <td>
                    <CButton
                      size="sm"
                      class="mr-1 btn-brand custom-btn-light"
                      @click="OpenUpdateSchedule(item)"
                    >
                      <CIcon name="cil-pencil" />
                    </CButton>
                    <CButton
                      size="sm"
                      class="mr-1 btn-brand"
                      color="danger"
                      @click="OpenDeleteSchedule(item)"
                    >
                      <CIcon name="cil-trash" />
                    </CButton>
                  </td>
                </tr>
              </tbody>
            </table>

            <CDataTable
              :small="small"
              :fixed="fixed"
              :items="FilterWeeklySchedule"
              :fields="fieldWeekly"
              items-per-page-select
              :items-per-page="small ? 5 : 5"
              clickable-rows
              sorter
              pagination
              columnFilter
              tableFilter
            >
              <template #StartDate="{ item }">
                <td>
                  {{ item.StartDate }}
                </td>
              </template>
              <template #EndDate="{ item }">
                <td>{{ item.EndDate }}</td>
              </template>
            </CDataTable>
          </div>
          </CCard>
        </div>
      </CCol>

      <br />
      <CCol sm="12">
        <div>
          <CRow>
            <CCol sm="4"> </CCol>
            <CCol sm="4"></CCol>
            <CCol sm="4"></CCol>
          </CRow>
        </div>
        <!-- <div style="overflow-x: inherit;"> -->
          <CDataTable
            :small="small"
            :fixed="fixed"
            :items="user.validTo < currentDate ? FilteredSubjectsList.slice(0, 5) : FilteredSubjectsList"
            :fields="fields"
            items-per-page-select
            :items-per-page="small ? 5 : 10"
            clickable-rows
            pagination
            sorter
            hover  
            class="no-scroll"
            tableFilter
          >
            <!-- <span style="overflow-x: inherit;"> -->
              <template #SubjectName="{ item }">
                <td>
                  <h6 style="color: #1e109c" class="text-uppercase">
                    {{ item.SubjectName }}
                  </h6>
                  <!-- <div class="small text-muted">Grade : {{ item.Grade }}</div>
                  <div class="small text-muted">Class : {{ item.ClassName }}</div> -->
                </td>
              </template>

              <template #Schedule="{ item }">
                <td>
                  <tr v-for="weeks in item.WeeklySchedules" v-bind:key="weeks.Id">
                    <li>
                      {{ weeks.ScheduleTime | moment("DD/MM/YYYY") }}
                      ({{ weeks.ScheduleTime | moment("HH:mm") }} -
                      {{ weeks.ScheduleTimeEnd | moment("HH:mm") }})
                    </li>
                  </tr>
                </td>
              </template>

              <template #Teachers="{ item }">
                <td>
                  <tr v-for="tea in item.Teachers" v-bind:key="tea.Id">
                    <li>{{ tea.Name }}</li>
                  </tr>
                </td>
              </template>

              <template #StudentFee="{ item }">
                <td>
                  {{ item.StudentFee }}
                </td>
              </template>

              <template #TeacherRate="{ item }">
                <td>
                  <tr v-for="rate in item.RateTeacher" v-bind:key="rate.Id">
                    <li>{{ rate.Hour }} hour : RM {{ rate.Rate }}</li>
                  </tr>
                </td>
              </template>

              <template #Action="{ item }">
                <td>
                  <CDropdown
                    toggler-text="Action"
                    class="m-2 btn-act"
                    color="primary"
                  >
                    <CDropdownItem @click="OpenSchedule(item)"
                      >Set Schedule</CDropdownItem
                    >
                    <CDropdownItem @click="OpenReport(item)"
                      >Report Card</CDropdownItem
                    >
                    <CDropdownItem @click="OpenAssignTeacher(item)"
                      >Assign Teacher</CDropdownItem
                    >
                    <CDropdownDivider />
                    <CDropdownItem @click="OpenUpdate(item)">Edit</CDropdownItem>
                    <CDropdownItem @click="OpenDeleteSubject(item)"
                      >Delete</CDropdownItem
                    >
                  </CDropdown>
                </td>
              </template>
            <!-- </span> -->
          </CDataTable>
        <!-- </div> -->
      </CCol>

      <!-- Modal Add Subject -->
      <CModal
        title="Add New Subject"
        size="md"
        :show.sync="SubjectModal"
        :close-on-backdrop="false"
        :close-on-esc="false"
      >
        <div>
          <h6><strong>FORM SUBJECT</strong></h6>
          <br />
          <CCol sm="12">
            <CRow>
              <CCol sm="4"> Subject name </CCol>
              <CCol sm="8">
                <CInput type="text" v-model="Name" />
              </CCol>

              <CCol sm="4"> Grade Name </CCol>
              <CCol sm="8">
                <v-select
                  v-model="selectedGradeName"
                  :options="gradesName"
                  label="Name"
                  placeholder="--Please Select Grade--"
                ></v-select>
                <br />
              </CCol>
              <CCol sm="4"> Class name </CCol>
              <CCol sm="8">
                <v-select
                  v-model="selectedClassName"
                  :options="classes"
                  label="Name"
                  placeholder="Please Select Class"
                >
                </v-select>
                <br />
              </CCol>
              <CCol sm="4"> Student Rate (per Month) or (per Hour)  {{ user.currencyCode }}</CCol>
              <CCol sm="8">
                <CInput type="text" v-model="StudentFee" />
                <br />
              </CCol>
              <CCol sm="12">
                <br />
                <h6><strong>Teacher Rate (Hours)</strong></h6>
                <br />
                <CButton
                  class="button mr-2 mt-2 btn-success"
                  @click="AddHourRate"
                  size="sm"
                >
                  <CIcon name="cil-plus" />Add New Teacher Rate
                </CButton>
                <table class="table" v-if="teacherRates.length > 0">
                  <thead>
                    <th>Hour</th>
                    <th>Rate</th>
                    <th></th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in teacherRates"
                      v-bind:key="item.Id"
                    >
                      <td><CInput type="text" v-model="item.Hours" /></td>
                      <td><CInput type="text" v-model="item.Rate" /></td>
                      <td>
                        <button
                          type="button"
                          class="text-center button btn-xs btn-danger"
                          v-on:click="removeRow(index)"
                        >
                          -
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CCol>
            </CRow>
          </CCol>
        </div>
        <template #footer>
          <CButton
            type="submit"
            class="p-2"
            color="info"
            @click="SubmitSubject()"
            >{{ lblBtn }}</CButton
          ></template
        >
      </CModal>

      <!-- Modal Add Grade -->
      <CModal
        title="Add New Grade"
        size="md"
        :show.sync="GradeModal"
        :close-on-backdrop="false"
        :close-on-esc="false"
      >
        <div>
          <h6><strong>FORM GRADE</strong></h6>
          <br />
          <CCol sm="12">
            <CRow>
              <CCol sm="3"> Grade </CCol>
              <CCol sm="9">
                <CInput type="text" v-model="GradeTc" />
              </CCol>
              <CCol sm="3"> Class </CCol>
              <CCol sm="9">
                <CInput type="text" v-model="ClassTc" />
              </CCol>
              <div style="clear: both"></div>
              <hr />
              <CCol sm="12">
                <CDataTable
                  :small="small"
                  :fixed="fixed"
                  :items="FilteredGradeClass"
                  :fields="fieldGradeClass"
                  items-per-page-select
                  :items-per-page="small ? 5 : 5"
                  clickable-rows
                  pagination
                  table-filter
                >
                  <template #Grade="{ item }">
                    <td>
                      {{ item.Grade }}
                    </td>
                  </template>

                  <template #ClassName="{ item }">
                    <td>
                      {{ item.ClassName }}
                    </td>
                  </template>
                  <template #Action="{ item }">
                    <td>
                      <CButton
                        type="button"
                        class="btn btn-danger"
                        @click="OpenDeleteGrade(item)"
                      >
                        <CIcon name="cil-trash"
                      /></CButton>
                    </td>
                  </template>
                </CDataTable>
              </CCol>
            </CRow>
          </CCol>
        </div>
        <template #footer>
          <CButton
            type="submit"
            class="p-2"
            color="info"
            @click="SubmitGrade()"
            >{{ lblBtnGrade }}</CButton
          ></template
        >
      </CModal>

      <!-- Modal Set Schedule -->
      <CModal
        title="Schedule Recurrence"
        size="md"
        :show.sync="ScheduleModal"
        :close-on-backdrop="false"
        :close-on-esc="false"
      >
        <!-- <div>
          <h6><strong>SCHEDULE DATE</strong></h6>
          <br />

          <CCol sm="12">
            <CRow>
              <CCol sm="3">Start Date </CCol>
              <CCol sm="9">
                <CInput type="datetime-local" v-model="ScheduleDateTime" />
              </CCol>

              <CCol sm="3">End Date</CCol>
              <CCol sm="9">
                <CInput type="datetime-local" v-model="ScheduleDateTimeEnd" />
              </CCol>
            </CRow>
          </CCol>
          <br />
      
          <h6><strong>RECURRENCE PATTERN</strong></h6>
          <br />
          <CCol sm="12">
            <CRow>
              <CCol sm="3">Repeat For Every</CCol>
              <CCol sm="6">
                <CInput type="number" v-model="interval" />
              </CCol>
              <CCol sm="3">days</CCol>
              <hr />

              <CCol sm="3">Theme Color</CCol>
              <CCol sm="9">
                <v-select
                  v-model="selectedColor"
                  :options="optionsColor"
                  placeholder="--Please Select Theme--"
                  class="custom-dropdown"
                  label="Name"
                ></v-select>
                <br />
              </CCol>
              <hr />
              <CCol sm="3">Teacher</CCol>
              <CCol sm="9">
                <v-select
                  v-model="selectedTeachers"
                  :options="teachers"
                  label="Name"
                  placeholder="--Please Select Teacher--"
                  data-backdrop="static"
                  data-keyboard="false"
                ></v-select>
              </CCol>
            </CRow>
          </CCol>
        </div> -->
        <div>
          <label class="custom-16px mt-3">Schedule Subject</label>
              <v-select
                v-model="SelectedSubjectNames"
                :options="subjects"
                label="SubjectName"
                placeholder="--Please Select Subject--"
                class="custom-vselect no-bordered"
              ></v-select>
              <br />

              <label>Note : Repeat is based on how many time you want to repeat.
                <br />e.g 1 for 1 week.</label><br />

              <label class="custom-16px mt-1"
                >Repeat For Every</label
              >
              <input
                type="number"
                v-model="intervals"
                class="custom-input-user"
              />
              week

              <br />
                <br />
              <label>Note : Start Time Date and End Time Date must be same.</label><br />

              <CRow>
                <CCol sm="6">
                  <label class="custom-16px mt-2">Start Time</label>
                  <CInput type="datetime-local" v-model="ScheduleDateTimes" />
                </CCol>
                <CCol sm="6">
                  <label class="custom-16px mt-2">End Time</label>
                  <CInput
                    type="datetime-local"
                    v-model="ScheduleDateTimeEnds"
                  />
                </CCol>
              </CRow>

              <label class="custom-16px">Theme Color</label>
              <v-select
                v-model="selectedColor"
                :options="optionsColor"
                placeholder="--Please Select Theme--"
                class="custom-vselect no-bordered"
                label="Name"
              ></v-select>

              <label class="custom-16px mt-2">Teacher</label>
              <!-- <v-select
                v-model="selectedTeachers"
                :options="teachers"
                  label="Name"
                placeholder="--Please Select Teacher--"
                class="custom-vselect no-bordered"
              ></v-select> -->

              <v-select
                  v-model="selectedTeacher"
                  :options="teachers"
                  label="Name"
                  placeholder="--Please Select Teacher--"
                  class="custom-vselect no-bordered"
                ></v-select>
              <br />
        </div>
        <template #footer>
          <CButton
            type="submit"
            class="p-2"
            color="info"
            @click="SubmitSchedule"
          >
            {{ lblBtnSchedule }}</CButton
          ></template
        >
      </CModal>

      <!-- Modal Report Card -->
      <CModal 
        title="Report Card" 
        size="md" 
        :show.sync="ReportModal"
        :close-on-backdrop="false"
        :close-on-esc="false"
      >
        <div>
          <h6><strong>DETAIL SUBJECT</strong></h6>
          <br />

          <CCol sm="12">
            <CRow>
              <CCol sm="12">
                Subject Info : {{ subjectsDetails.SubjectName }}
                <br />
                Grade : {{ subjectsDetails.Grade }}
                <br />
                Class: {{ subjectsDetails.ClassName }}
                <br />
                <br />
              </CCol>
            </CRow>
          </CCol>
          <br />
          <h6><strong>ADD REPORT CARD</strong></h6>
          <br />
          <CCol sm="12">
            <CRow>
              <CCol sm="4">Student Name</CCol>
              <CCol sm="8">
                <v-select
                  v-model="selectedStudents"
                  :options="students"
                  label="Name"
                  placeholder="--Please Select Student--"
                ></v-select>
                <br />
              </CCol>

              <CCol sm="4"> Month Name </CCol>
              <CCol sm="8">
                <CInput type="text" v-model="MonthName" />
              </CCol>
              <CCol sm="4"> Test Name </CCol>
              <CCol sm="8">
                <CInput type="text" v-model="TestName" />
              </CCol>
              <CCol sm="4"> Score </CCol>
              <CCol sm="8">
                <CInput type="number" v-model="Score" />
              </CCol>
            </CRow>
          </CCol>

          <!-- <CDataTable
              :small="small"
              :fixed="fixed"
              :items="FilteredReportCard"
              :fields="fieldReport"
              items-per-page-select
              :items-per-page="small ? 5 : 5"
              clickable-rows
              pagination
            >
              <template #Name="{ item }">
                <td>
                  {{ item.Name }}
                </td>
              </template>
              <template #Test="{ item }">
                <table class="table">
                  <tbody>
                    <tr>
                      <td>
                        <tr v-for="it in item.ReportCard" v-bind:key="it.Id">
                          <td>{{ it.TestName }}</td>
                          <td>{{ it.MonthName }}</td>
                          <td>{{ it.Score }}</td>
                          <td>
                            <CButton
                              type="button"
                              class="btn btn-info"
                              @click="OpenUpdateReportCard(it)"
                            >
                              <CIcon name="cil-pencil"
                            /></CButton>
                            <CButton
                              type="button"
                              class="btn btn-danger ml-2"
                              @click="OpenDeleteReportCard(it)"
                            >
                              <CIcon name="cil-trash"
                            /></CButton>
                          </td>
                        </tr>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </template>
            </CDataTable> -->
        </div>

        <template #footer>
          <CButton
            type="submit"
            class="p-2"
            color="info"
            @click="CreateReportCard(subjectsDetails.ID)"
            >Proceed</CButton
          ></template
        >
      </CModal>

      <!-- Modal Assign Teacher -->
      <CModal
        title="Assign Teacher"
        size="md"
        :show.sync="AssignTeacherModal"
        :close-on-backdrop="false"
        :close-on-esc="false"
        hide-footer
      >
        <div>
          <h6><strong>DETAIL SUBJECT</strong></h6>
          <br />

          <CCol sm="12">
            <CRow>
              <CCol sm="12">
                Subject Info : {{ subjectsData.SubjectName }}
                <br />
                Grade : {{ subjectsData.Grade }}
                <br />
                Class: {{ subjectsData.ClassName }}
                <br />
                <br />
              </CCol>
            </CRow>
          </CCol>
          <br />
          <h6><strong>ADD ASSIGN TEACHER</strong></h6>
          <br />
          <CCol sm="12">
            <CRow>
              <CCol sm="4"> Teacher</CCol>
              <CCol sm="8">
                <v-select
                  v-model="selectedTeacher"
                  :options="teachers"
                  label="Name"
                  placeholder="--Please Select Teacher--"
                ></v-select>
                <br />
                <div class="float-right">  <CButton
            type="submit"
            class="p-2"
            color="info"
            @click="CreateAssignTeacher(subjectsData.ID)"
            >{{ lblAssign }}</CButton
          ></div>
              
              </CCol>
              <CCol sm="12">
               
              </CCol>
            </CRow>
          </CCol>
        </div>
        <br />
        <br />
        <h6><strong>REMOVE TEACHER</strong></h6>
        <CDataTable
          :small="small"
          :fixed="fixed"
          :items="FilteredTeacherList"
          :fields="fieldTeachers"
          items-per-page-select
          :items-per-page="small ? 5 : 5"
          clickable-rows
          pagination
        >
          <template #Name="{ item }">
            <td>
              {{ item.Name }}
            </td>
          </template>
          <template #Action="{ item }">
            <td>
              <CButton
                type="button"
                class="btn btn-danger"
                @click="OpenDeleteTeachers(item, subjectsData.ID)"
              >
                <CIcon name="cil-trash"
              /></CButton>
            </td>
          </template>
        </CDataTable>

        <template #footer>
    <div style="border-top: none;border:1px solid transparent">
      <!-- Add your custom HTML elements for the footer here -->
      <CButton style="display:none">OK</CButton> 
      <CButton style="display:none">Cancel</CButton> 
    </div>
        </template>
      </CModal>

      <!-- Modal Edit Subject -->
      <CModal
        title="Edit Subject"
        size="md"
        :show.sync="EditSubjectModal"
        :close-on-backdrop="false"
        :close-on-esc="false"
      >
        <div>
          <h6><strong>DETAIL SUBJECT</strong></h6>
          <br />
          <CCol sm="12">
            <CRow>
              <CCol sm="5">Subject name</CCol>
              <CCol sm="7">
                <CInput type="text" v-model="SubjectNames" />
              </CCol>
              <CCol sm="5"> Grade Name </CCol>
              <CCol sm="7">
                <v-select
                  v-model="SelectedGradeNames"
                  :options="gradesName"
                  label="Name"
                  placeholder="--Please Select Grade--"
                ></v-select>
                <br />
              </CCol>

              <CCol sm="5"> Class name </CCol>
              <CCol sm="7">
                <v-select
                  v-model="SelectedClassNames"
                  :options="classes"
                  label="Name"
                  placeholder="Please Select Class"
                >
                </v-select>
                <br />
              </CCol>
              <CCol sm="5"> Student Rate (per Month) or (per Hour) </CCol>
              <CCol sm="7">
                <CInput type="number" v-model="StudentFees" />
              </CCol>

              <!-- <CCol sm="5"> Meeting ID</CCol>
              <CCol sm="7">
                <CInput type="text" v-model="MeetingId" />
              </CCol>

              <CCol sm="5">Meeting Password</CCol>
              <CCol sm="7">
                <CInput type="text" v-model="MeetingPassword" />
              </CCol>

              <CCol sm="5"> Meeting Link </CCol>
              <CCol sm="7">
                <CInput type="text" v-model="MeetingLink" />
              </CCol>

              <CCol sm="5"> Additional Link </CCol>
              <CCol sm="12">
                <tinymce
  id="d1"
  v-model="AdditionalLink"
  :init="{
    height: 300,
    menubar: false,
    plugins: 'link lists code',
    toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | bullist numlist outdent indent | link code'
  }"
/>
              </CCol> -->

              <CCol sm="8" class="mt-4 mb-3">
                <h6>
                  <strong>DETAIL RATE TEACHER</strong>
                </h6></CCol
              >
              <CCol sm="4" class="mt-4 mb-3">
                <CButton
                  class="button mr-2 mt-2 btn-success"
                  @click="AddHourRate"
                  size="sm"
                >
                  <CIcon name="cil-plus" /> Add New Rate
                </CButton></CCol
              >
              <br />
              <table class="table">
                <thead>
                  <th>Hour</th>
                  <th>Rate</th>
                  <th></th>
                </thead>
                <tbody>
                  <tr v-for="item in teacherRate" v-bind:key="item.Id">
                    <td>{{ item.Hour }}</td>
                    <td>{{ item.Rate }}</td>
                    <td>
                      <CButton
                        type="button"
                        class="btn-danger"
                        @click="OpenDeleteTeacherRate(item)"
                        >X Delete</CButton
                      >
                    </td>
                  </tr>
                  <tr
                    v-for="(item, index) in teacherRates"
                    v-bind:key="item.Id"
                  >
                    <td><CInput type="text" v-model="item.Hours" /></td>
                    <td><CInput type="text" v-model="item.Rate" /></td>
                    <td>
                      <button
                        type="button"
                        class="text-center button btn-xs btn-danger"
                        v-on:click="removeRow(index)"
                      >
                        -
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </CRow>
          </CCol>
        </div>
        <template #footer>
          <CButton
            type="submit"
            class="p-2"
            color="info"
            @click="UpdateSubject(SubjectId)"
            >{{ lblSubject }}</CButton
          ></template
        >
      </CModal>
    </div>

      <!-- Modal Delete Subject -->
      <CModal 
        size="md" 
        :show.sync="DeleteSubject"
        :close-on-backdrop="false"
        :close-on-esc="false"
      >
        <div class="text-center">
          <h3 class="custom-title-popup" style="color: #000a2c">
            Delete Subject
          </h3>
          <br />
        </div>
        <div class="text-center">
          <h4 class="sub-title-header" style="color: #000a2c">
            Are you sure you want to delete the<br />
            subject?
          </h4>
          <br />
        </div>
        <template #footer>
          <div class="text-center">
            <CButton
              type="submit"
              size="lg"
              color="info"
              @click="DeleteSubjects()"
              >Yes, sure.</CButton
            >
          </div>
        </template>
      </CModal>
  </div>
</template>


<script>
import _ from "lodash";
import Vue from "vue";
import $ from "jquery";
Vue.use(require("vue-moment"));
import moment from "moment";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";


import tinymce from "vue-tinymce-editor";
Vue.component("tinymce", tinymce);

Vue.use(VuejsDialog);
import jQuery from "jquery";

export default {
  components: {
    PulseLoader,
  },
  data() {
    return {
      subjects: [],
      SearchQuery: "",
      FilteredSubjects: [],

      selectedGrade: "ALL GRADE",
      gradeOptions: [],

      selectedClass: "ALL CLASS",
      classOptions: [],

      perPage: 10,
      pagination: {},
      currentPage: 1,
      DeleteSubject: false,

      Busy: false,
      headers: [
        { text: "Name", value: "name" },
        { text: "Address", value: "address" },
        { text: "Height", value: "height", sortable: true },
        { text: "Weight", value: "weight", sortable: true },
        { text: "Age", value: "age", sortable: true },
        { text: "Favourite sport", value: "favouriteSport" },
        { text: "Favourite fruits", value: "favouriteFruits" },
      ],

      fields: [
        { key: "SubjectName" },
        { key: "Schedule" },
        { key: "Teachers" },
        { key: "StudentFee" },
        { key: "TeacherRate" },
        { key: "Action" },
      ],

      fieldGradeClass: [
        { key: "Grade" },
        { key: "ClassName" },
        { key: "Action" },
      ],

      fieldReport: [{ key: "Name" }, { key: "Test" }],
      fieldTeachers: [{ key: "Name" }, { key: "Action" }],

      fieldWeekly: [
        { key: "StartDate" },
        { key: "EndDate" },
        { key: "Day" },
        { key: "ScheduleTime" },
        { key: "ScheduleTimeEnd" },
      ],

      FormSubject: false,
      FormGrade: false,
      FormSchedule: false,
      FormReport: false,

      UpdateFormSubject: false,

      gradesName: [],
      classes: [],

      Name: "",
      selectedGradeName: "",
      selectedClassName: "",
      StudentFee: "",

      teacherRates: [],

      Hours: "",
      Rate: "",

      small: "",
      fixed: "",

      GradeTc: "",
      ClassTc: "",

      subjectsSchedule: {},

      options: [
        {
          Id: 1,
          dayName: "Monday",
        },
        {
          Id: 2,
          dayName: "Tuesday",
        },
        {
          Id: 3,
          dayName: "Wednesday",
        },
        {
          Id: 4,
          dayName: "Thursday",
        },
        {
          Id: 5,
          dayName: "Friday",
        },
        {
          Id: 6,
          dayName: "Saturday",
        },
        {
          Id: 7,
          dayName: "Sunday",
        },
      ],

      selectedColor: "",
      optionsColor: [
        {
          Id: 1,
          Name: "blue",
        },
        {
          Id: 2,
          Name: "red",
        },
        {
          Id: 3,
          Name: "green",
        },
        {
          Id: 4,
          Name: "purple",
        },
        {
          Id: 5,
          Name: "violet",
        },
      ],
      StartDate: "",
      EndDate: "",
      selectedDay: "",
      ScheduleTime: "",
      ScheduleTimeEnd: "",

      weeklySchedule: [],

      EditSchedule: false,

      subjectsDetails: {},
      students: [],
      selectedStudents: "",
      MonthName: "",
      TestName: "",
      Score: "",

      gradesTc: [],
      FilteredGradeClass: [],
      teachers: [],
      selectedTeacher: "",
      FormAssignTeacher: false,
      teacherList: [],

      subjectsData: [],
      FilteredTeacherList: [],

      FilteredReportCard: [],
      updateReportCard: false,
      MonthNames: "",
      TestNames: "",
      Scores: "",

      FilterWeeklySchedule: [],

      gridData: [
        {
          name: "Chuck Norris",
          power: Infinity,
        },
        {
          name: "Bruce Lee",
          power: 9000,
        },
        {
          name: "Jackie Chan",
          power: 7000,
        },
        {
          name: "Jet Li",
          power: 8000,
        },
      ],

      ScheduleModal: false,
      ScheduleDateTime: "",
      ScheduleDateTimeEnd: "",
      interval: 0,
      selectedTeachers: "",

      ReportModal: false,

      AssignTeacherModal: false,

      SubjectNames: "",
      selectedGradeNames: "",
      selectedClassNames: "",
      StudentFees: "",

      EditSubjectModal: false,

      SelectedGradeNames: {},
      SelectedClassNames: {},

      teacherRate: [],

      SubjectModal: false,
      GradeModal: false,
      SearchQueryTeacher: "",


      lblBtn: "Proceed",
      lblBtnGrade: "Proceed",
      lblBtnSchedule: "Proceed",
      lblAssign: "Assign Teacher",
      lblSubject: "Proceed",

      SelectedSubjectNames: {},
      subjectsDataSchedule: [],

      ScheduleDateTimes: "",
      ScheduleDateTimeEnds: "",
      intervals: 1,

      user: {},
      currentDate: new Date().toISOString().substring(0, 10),
      check: {},

      MeetingId: "",
      MeetingPassword: "",
      MeetingLink: "",
      AdditionalLink: ""

    };
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetSubject();
      this.GetClass();
      this.GetGrade();
      this.GetSubjectList();
    } else {
      this.GoToLogin();
    }
  },
  watch: {
  gradesName(newVal) {
    if (newVal.length > 0 && this.GradeNames) {
      this.SetupSelectedOption();
    }
  },
  classes(newVal) {
    if (newVal.length > 0 && this.ClassNames) {
      this.SetupSelectedOption();
    }
  }
},
  computed: {
    FilteredSubjectsList() {
  if (this.SearchQuery === "") return this.FilteredSubjects;

  const query = this.SearchQuery.toLowerCase();

  return this.FilteredSubjects.filter((item) => {
    // Check teacher names
    const teacherMatch = item.Teachers.some(({ Name }) => Name.toLowerCase().includes(query));

    // Check teacher rates
    const rateMatch = item.RateTeacher.some(({ Hour, Rate }) =>
      Hour.toString().includes(query) || Rate.toString().includes(query)
    );

    // Check schedules
    const scheduleMatch = item.WeeklySchedules.some(({ ScheduleTime, ScheduleTimeEnd }) =>
      ScheduleTime.toString().includes(query) || ScheduleTimeEnd.toString().includes(query)
    );

    // Check subject name
    const subjectMatch = item.SubjectName.toLowerCase().includes(query);

    // Check grade name
    const gradeMatch = item.Grade.toLowerCase().includes(query);

    // Check class name
    const classMatch = item.ClassName.toLowerCase().includes(query);

    // Check student fee
    const fee = item.StudentFee?.toString() || "";
    const feeMatch = fee.includes(query);

    // Return true if any match is found
    return teacherMatch || rateMatch || scheduleMatch || subjectMatch || gradeMatch || classMatch || feeMatch;
  });
},


  },

  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetCheckTc(this.user.tuitioncenter);
          }
        });
    },
    GetCheckTc(tuitioncenter) {
      return this.$API
        .get(this.$GetCheckTcPackage + "?TuitionCenterId=" + tuitioncenter, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.check = response.data;
          }
        });
    },
    OpenUpdateSchedule(item) {
      this.Id = item.Id;
      this.$API
        .get(this.$GetWeeklyScheduleById + "?weekId=" + this.Id, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.StartDate = this.info.StartDate;
            this.EndDate = this.info.EndDate;
            this.ScheduleTime = this.info.ScheduleTime;
            this.ScheduleTimeEnd = this.info.ScheduleTimeEnd;
            console.log("date" + this.StartDate);
          }
        });
      this.EditSchedule = true;
    },
    RefreshData() {
      this.GetSubject();
    },
    AddHourRate() {
      var lastId = 1;
      var length = this.teacherRates.length;
      if (length > 0) lastId = this.teacherRates[length - 1].Id;

      this.teacherRates.push({
        Id: lastId + 1,
        Hours: 1,
        Rate: 1,
      });
    },
    removeRow: function (index) {
      this.teacherRates.splice(index, 1);
    },
    OpenFormSubject() {
      this.SubjectModal = true;
    },
    CloseSubject() {
      this.FormSubject = false;
    },
    OpenFormGrade() {
      this.$API
        .get(this.$GetGradeClasses, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.gradesTc = response.data;
            this.FilteredGradeClass = this.gradesTc;
          }
        });
      this.GradeModal = true;
    },
    CloseGrade() {
      this.FormGrade = false;
    },
    OpenUpdate(item) {
     
  this.subjectId = item.SubjectId;

  this.$API
    .get(this.$GetRateTeacherById + "?id=" + this.subjectId, {
      withCredentials: true,
    })
    .then((response) => {
      if (response.status == 200 && response.data != null) {
        this.teacherRate = response.data;
      }
    });

  this.$API
    .get(this.$GetSubjectById + "?id=" + this.subjectId, {
      withCredentials: true,
    })
    .then((response) => {
      this.info = response.data;
      if (response.status == 200 && this.info != null) {
        this.SubjectNames = this.info.SubjectName;
        this.GradeNames = this.info.Grade;
        this.ClassNames = this.info.ClassName;
        this.StudentFees = this.info.StudentFee;
        this.SubjectId = this.info.SubjectId;
        this.TeacherUserId = this.info.TeacherUserId;
        this.MeetingId = this.info.MeetingId;
        this.MeetingLink = this.info.MeetingLink;
        this.MeetingPassword = this.info.Password;
        this.AdditionalLink = this.info.AdditionalLink || "";
        // ✅ now update TinyMCE after data loaded
        this.$nextTick(() => {
          if (window.tinymce) {
            const editor = tinymce.get("d1");
            if (editor) {
              editor.setContent(this.AdditionalLink || "");
            }
          }
        });



        // fetch class & grade then setup selection
        Promise.all([this.GetClass(), this.GetGrade()]).then(() => {
          this.SetupSelectedOption();
        });
      }
    });

  this.EditSubjectModal = true;
},
SetupSelectedOption() {
  this.SelectedGradeNames =
    this.gradesName.find(
      (g) => g.Name.trim().toLowerCase() === this.GradeNames.trim().toLowerCase()
    ) || null;

  this.SelectedClassNames =
    this.classes.find(
      (c) => c.Name.trim().toLowerCase() === this.ClassNames.trim().toLowerCase()
    ) || null;
},
    CloseFormSubject() {
      this.UpdateFormSubject = false;
    },
    
    OpenSchedule(item) {
      this.subIds = item.SubjectId;

      this.$API
        .get(this.$ViewSubject, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.subjects = response.data;
          }
        });
        this.$API
        .get(this.$GetScheduleBySubjectId + "?subjectId=" + this.subIds, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && response.data != null) {
            this.subjectsNameSchedule = this.info.SubjectName;
            this.SetupSelectedOption(this.subjectsNameSchedule);

          }
        });

      this.$API
        .get(this.$GetScheduleBySubjectId + "?subjectId=" + this.subIds, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjectsSchedule = response.data;
          }
        });
      this.$API
        .get(this.$ViewTeacher, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teachers = response.data;
          }
        });

      this.ScheduleModal = true;

      //this.FormSchedule = true;
    },
    // SetupSelectedOption(subjectsNameSchedule) {
    //   console.log("subject" + subjectsNameSchedule);
    //   this.SelectedSubjectNames = _.find(this.subjects, {
    //     SubjectName: subjectsNameSchedule,
    //   });
      
    // },
    CloseAddSchedule() {
      this.FormSchedule = false;
    },

    OpenAssignTeacher(item) {
      this.subId = item.SubjectId;

      // window.open("/TuitionSubjectSetSchedule?subjectId=" + this.subId,"_blank");
      this.$API
        .get(this.$GetScheduleBySubjectId + "?subjectId=" + this.subId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjectsData = response.data;
          }
        });
      this.$API
        .get(this.$ViewTeacher, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teachers = response.data;
          }
        });
      this.$API
        .get(this.$GetListTeacherBySubId + "?subjectId=" + this.subId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teacherList = response.data;
            this.FilteredTeacherList = this.teacherList;
          }
        });
      this.AssignTeacherModal = true;
    },
    CloseAssignTeacher() {
      this.FormAssignTeacher = false;
    },
    OpenReport(item) {
      this.subId = item.SubjectId;
      this.$API
        .get(this.$GetScheduleBySubjectId + "?subjectId=" + this.subId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjectsDetails = response.data;
          }
        });

      this.$API
        .get(this.$GetStudentReportCard + "?subjectId=" + this.subId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.students = response.data;
          }
        });

      this.$API
        .get(this.$GetListReportCardBySubId + "?subjectId=" + this.subId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.reportCards = response.data;
            this.FilteredReportCard = this.reportCards;
          }
        });

      this.ReportModal = true;
    },
    CloseReport() {
      this.FormReport = false;
    },

    GetSubject() {
      this.Busy = true;
      this.$API
        .get(this.$ViewSubject, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.subjects = response.data;
            this.FilteredSubjects = this.subjects;

            var gradeNames = _.uniq(_.map(response.data, "Grade"));
            gradeNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.gradeOptions = gradeNames;
            this.gradeOptions.unshift("ALL GRADE");

            var classNames = _.uniq(_.map(response.data, "ClassName"));
            classNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.classOptions = classNames;
            this.classOptions.unshift("ALL CLASS");
          }
        });
    },
    ApplyFilter: function () {
      var arr = _.orderBy(this.FilteredSubjects, ["SubjectName"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        const result = _.filter(arr, ({ SubjectName, Teachers }) =>
          _.some([
            _.includes(!SubjectName || SubjectName.toLowerCase(), [
              this.SearchQuery.toLowerCase(),
            ]),
          ])
        );
        this.FilteredSubjects = result;
      }
    },
    FilteredData() {
      console.log("masuk");
      this.FilteredSubjects = this.subjects;

      if (this.selectedGrade !== "ALL GRADE")
        this.FilteredSubjects = _.filter(
          this.FilteredSubjects,
          (item) => item.Grade === this.selectedGrade
        );

      if (this.selectedClass !== "ALL CLASS")
        this.FilteredSubjects = _.filter(
          this.FilteredSubjects,
          (item) => item.ClassName === this.selectedClass
        );
    },
    //   FilteredData() {
    //   const value= this.SearchQuery.charAt(0).toUpperCase() + this.SearchQuery.slice(1);
    //   return this.subjects.filter(function(subjects){
    //     return (
    //     	subjects.SubjectName.indexOf(value) > -1 ||
    //      	subjects.Grade.indexOf(value) > -1 ||
    //       subjects.ClassName.indexOf(value) > -1 ||
    //       subjects.Teachers.Name.indexOf(value) > -1 ||
    //       subjects.StudentFee.indexOf(value) > -1 ||
    //       subjects.RateTeacher.Hour.indexOf(value) > -1 ||
    //       subjects.RateTeacher.Rate.indexOf(value) > -1
    //     )
    //   });
    // },
    GetClass() {
  return this.$API
    .get(this.$ListClassTc, { withCredentials: true })
    .then((response) => {
      if (response.status === 200 && response.data != null) {
        this.classes = response.data;
      }
    });
},

GetGrade() {
  return this.$API
    .get(this.$ListGradeTc, { withCredentials: true })
    .then((response) => {
      if (response.status === 200 && response.data != null) {
        this.gradesName = response.data;
      }
    });
},

    async SubmitSubject() {
      if (
        this.Name === "" ||
        this.selectedGradeName.Name === "" ||
        this.selectedClassName.Name === ""
      ) {
        this.Error = true;
        this.Message = "Please Complete all the forms";
      } else {
        setTimeout(() => {
          this.SubjectModal = false; // set the SubjectModal value to false to close the modal
        }, 5000);
        this.lblBtn = "Processing";
        this.Error = false;
        const formData = new FormData();

        formData.append("Name", this.Name);
        formData.append("Grade", this.selectedGradeName.Name);
        formData.append("ClassName", this.selectedClassName.Name);

        formData.append("StudentFee", this.StudentFee);

        var teacherRateJson = JSON.stringify(this.teacherRates);
        formData.append("teacherRatesJson", teacherRateJson);

        return this.$API
          .post(this.$InsertNewSubjectTc, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.lblBtn = "Proceed";
              this.$dialog
                .alert("Success save new subject")
                .then(function () {});
              this.RefreshData();
            } else {
              this.Busy = false;
              this.$dialog
                .alert("Error to create subject ")
                .then(function () {});
            }
          })
          .catch((error) => {
            this.Busy = false;
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
      }
    },

    UpdateSubject: function () {
      this.lblSubject = "Processing";
      const formData = new FormData();
      formData.append("Id", this.SubjectId);
      formData.append("Name", this.SubjectNames);
      formData.append("Grade", this.SelectedGradeNames.Name);
      formData.append("ClassName", this.SelectedClassNames.Name);

      formData.append("StudentFee", this.StudentFees ? this.StudentFees : 0);

      var teacherRateData = JSON.stringify(this.teacherRates);
      formData.append("teacherRatesJson", teacherRateData);

      formData.append("TuitionSubjectId", this.SubjectId);
// formData.append("MeetingId", this.MeetingId);
// formData.append("Password", this.MeetingPassword);
// formData.append("VcLink", this.MeetingLink);
// formData.append("UserId", this.TeacherUserId);
// formData.append("AdditionalLink", this.AdditionalLink);
      return this.$API
        .post(this.$UpdateTuitionSubject, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {


            this.lblSubject = "Proceed";
            this.EditSubjectModal = false;
              this.$dialog
                .alert("Success save update subject")
                .then(function () {});
              this.RefreshData();

          } else {
            this.Busy = false;
            this.$dialog.alert("Error to create subject ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    OpenDeleteTeacherRate(item) {
      const formData = new FormData();

      formData.append("Id", item.Id);

      return this.$API
        .post(this.$DeleteTeacherRate, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            this.$API
              .get(this.$GetRateTeacherById + "?id=" + this.subjectId, {
                withCredentials: true,
              })
              .then((response) => {
                if (response.status == 200 && response.data != null) {
                  this.teacherRate = response.data;
                }
              });
          } else console.log("Error Deleting");
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async SubmitGrade() {
      if (this.GradeTc === "" || this.ClassTc === "") {
        this.Error = true;
        this.Message = "Please Complete all the forms";
      } else {
        this.lblBtnGrade = "Processing";
        this.Error = false;
        const formData = new FormData();

        formData.append("Grade", this.GradeTc);
        formData.append("ClassName", this.ClassTc);

        return this.$API
          .post(this.$InsertNewGradeClassTc, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              setTimeout(() => {
                this.GradeModal = false; // set the SubjectModal value to false to close the modal
              }, 5000);
              this.lblBtnGrade = "Proceed";
              this.$dialog.alert("Success save new grade").then(function () {});
              this.RefreshData();
            } else {
              this.Busy = false;
              this.$dialog.alert("Error to save ").then(function () {});
            }
          })
          .catch((error) => {
            this.Busy = false;
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
      }
    },

    async CreateSchedule(ID) {
      this.TuitionSubjectId = ID;

      if (
        this.StartDate === "" ||
        this.EndDate === "" ||
        this.selectedDay.dayName === "" ||
        this.StartTime === "" ||
        this.EndTime === ""
      ) {
        this.Error = true;
        this.Message = "Please Complete all the forms";
      } else {
        this.Error = false;
        this.Busy = true;
        const formData = new FormData();

        formData.append("TuitionSubjectId", this.TuitionSubjectId);
        formData.append("StartDate", this.StartDate);
        formData.append("EndDate", this.EndDate);

        formData.append("ScheduleDay", this.selectedDay.dayName);
        formData.append(
          "ScheduleTime",
          moment(this.ScheduleTime).format("hh:mm A")
        );

        formData.append(
          "ScheduleTimeEnd",
          moment(this.ScheduleTimeEnd).format("hh:mm A")
        );

        return this.$API
          .post(this.$InsertNewScheduleBySubId, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.Busy = false;
              this.$dialog.alert("Success Save Schedule").then(function () {});
              this.FormSchedule = false;
              this.RefreshData();
            } else {
              this.Busy = false;
              this.$dialog.alert("Error to save ").then(function () {});
            }
          })
          .catch((error) => {
            this.Busy = false;
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
      }
    },

    OpenDeleteSchedule(item) {
      const formData = new FormData();

      formData.append("Id", item.Id);

      return this.$API
        .post(this.$DeleteWeeklySchedule, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            this.$dialog.alert("Details WeeklySchedule Deleted!");
            this.RefreshData();
          } else console.log("Error Deleting");
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async CreateReportCard(ID) {
      this.TuitionSubjectId = ID;

      const formData = new FormData();

      formData.append("TuitionSubjectId", this.TuitionSubjectId);
      formData.append("ManualStudentId", this.selectedStudents.ID);
      formData.append("Score", this.Score);

      formData.append("TestName", this.TestName);
      formData.append("MonthName", this.MonthName);

      return this.$API
        .post(this.$InsertNewReportCard, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.Busy = false;
            this.$dialog.alert("Success Save Report Card").then(function () {});
            this.ReportModal = false;
            this.RefreshData();
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to save ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },

    OpenDeleteGrade(item) {
      const formData = new FormData();

      formData.append("Id", item.Id);

      return this.$API
        .post(this.$DeleteGrade, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            this.$dialog.alert("Details Grade Deleted!");
            this.RefreshData();
            this.FormGrade = false;
          } else console.log("Error Deleting");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    OpenDeleteSubject(item) {
      // item.SubjectId = item.SubjectId
      // this.DeleteSubject = true;

      let message = "Are you sure want to delete the subject?";

      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: "Yes, sure.",
        cancelText: "Cancel",
        animation: "zoom", // Available: "zoom", "bounce", "fade"
        type: "basic", // coming soon: 'soft', 'hard'
        verification: "continue", // for hard confirm, user will be prompted to type this to enable the proceed button
        verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
        clicksCount: 3, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
        backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
        customClass: "", // Custom class to be injected into the parent node for the current dialog instance
      };

      this.$dialog
        .confirm(message, options)
        .then(async (response) => {
          // this.UpdateOfferAppStatus(statusId, index);
          await this.DeleteSubjects(item.SubjectId);
          //this.EmailOfferAppStatus(identityNo, index);
        })
        .catch(function () {});
    },
    DeleteSubjects(SubjectId) {
      const formData = new FormData();

      formData.append("Id", SubjectId);

      return this.$API
        .post(this.$DeleteSubject, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            this.$dialog.alert("Details Subjects Deleted!");
            this.RefreshData();
          } else console.log("Error Deleting");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async CreateAssignTeacher(ID) {
      this.lblAssign = "Processing";
      this.TuitionSubjectId = ID;

      const formData = new FormData();

      formData.append("TuitionSubjectId", this.TuitionSubjectId);
      formData.append("TeacherId", this.selectedTeacher.Id);

      return this.$API
        .post(this.$InsertAssignTeacher, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.Busy = false;

            this.$API
              .get(this.$GetListTeacherBySubId + "?subjectId=" + ID, {
                withCredentials: true,
              })
              .then((response) => {
                if (response.status == 200 && response.data != null) {
                  this.teacherList = response.data;
                  this.FilteredTeacherList = this.teacherList;

                  setTimeout(() => {
                    this.AssignTeacherModal = false; // set the SubjectModal value to false to close the modal
                  }, 5000);
                  this.lblAssign = "Proceed";
                  this.$dialog
                    .alert("Success save assign teacher")
                    .then(function () {});
                  this.RefreshData();
                }
              });

            // this.AssignTeacherModal = false;
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to save ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    OpenDeleteTeachers(item, ID) {
      const formData = new FormData();

      formData.append("Id", item.Id);

      return this.$API
        .post(this.$DeleteTeacherOnSubject, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            this.$dialog.alert("Details Deleted!");

            this.$API
              .get(this.$GetListTeacherBySubId + "?subjectId=" + ID, {
                withCredentials: true,
              })
              .then((response) => {
                if (response.status == 200 && response.data != null) {
                  this.teacherList = response.data;
                  this.FilteredTeacherList = this.teacherList;
                }
              });
            this.RefreshData();
            //this.FormAssignTeacher = false;
          } else console.log("Error Deleting");
        })
        .catch((error) => {
          console.log(error);
        });
    },

    OpenDeleteReportCard(it) {
      const formData = new FormData();

      formData.append("Id", it.Id);

      return this.$API
        .post(this.$DeleteReportCard, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            this.$dialog.alert("Details Deleted!");
            this.RefreshData();
            this.FormReport = false;
          } else console.log("Error Deleting");
        })
        .catch((error) => {
          console.log(error);
        });
    },

    OpenUpdateReportCard(item) {
      this.Id = item.Id;
      this.MonthNames = item.MonthName;
      this.TestNames = item.TestName;
      this.Scores = item.Score;
      this.updateReportCard = true;
    },
    UpdateReportCard: function () {
      const formData = new FormData();

      formData.append("Id", this.Id);
      formData.append("MonthName", this.MonthNames);
      formData.append("TestName", this.TestNames);
      formData.append("Score", this.Scores);

      return this.$API
        .post(this.$UpdateReportCard, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          console.log(response);
          if (response.status == 200) {
            this.$dialog.alert("Details Updated!");
            this.FormReport = false;
            this.RefreshData();
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // async SubmitSchedule(ID) {
    //   this.lblBtnSchedule = "Processing";
    //   this.subId = ID;

    //   const formData = new FormData();

    //   formData.append("TuitionSubjectId", this.subId);
    //   formData.append("ScheduleDateTime", this.ScheduleDateTime);
    //   formData.append("ScheduleDateTimeEnd", this.ScheduleDateTimeEnd);

    //   formData.append("TeacherId", this.selectedTeachers.Id);
    //   formData.append("ThemeColor", this.selectedColor.Name);

    //   formData.append("interval", this.interval);

    //   return this.$API
    //     .post(this.$InsertSchedule, formData, {
    //       withCredentials: true,
    //     })
    //     .then((response) => {
    //       if (response.status == 200) {
    //         setTimeout(() => {
    //           this.ScheduleModal = false; // set the SubjectModal value to false to close the modal
    //         }, 5000);
    //         this.lblBtnSchedule = "Proceed";
    //         this.$dialog.alert("Success save schedule").then(function () {});
    //         this.RefreshData();
    //       } else {
    //         this.Busy = false;
    //         this.$dialog.alert("Error to save ").then(function () {});
    //       }
    //     })
    //     .catch((error) => {
    //       this.Busy = false;
    //       this.Loading = false;
    //       this.Error = true;
    //       this.Message = error.response.data.message;
    //     });
    // },
    async SubmitSchedule() {
      this.lblBtnSchedule = "Processing";
      const formData = new FormData();

      formData.append("TuitionSubjectId", this.SelectedSubjectNames.SubjectId);

      formData.append("ScheduleDateTime", this.ScheduleDateTimes);

      formData.append("ScheduleDateTimeEnd", this.ScheduleDateTimeEnds);

      formData.append("TeacherId", this.selectedTeacher.Id);
      formData.append("ThemeColor", this.selectedColor.Name);

      formData.append("interval", this.intervals);
      return this.$API
        .post(this.$InsertScheduleNew, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            setTimeout(() => {
              this.ScheduleModal = false; // set the SubjectModal value to false to close the modal
            }, 5000);
            this.lblBtnSchedule = "Proceed";
            this.$dialog.alert("Success save schedule").then(function () {});
            this.RefreshData();
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to save ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    GoToRenew()
    {
      // window.open("https://www.pickiddo.com/RenewPackage?UserGroupId=" + this.user.usergroupId, "_blank");
      this.$router.push(
        "/Billing"
      );
    }
  },
};
</script>


<style scoped>
.form-group input .form-control {
  display: block;
  width: 100%;
  height: 45px !important;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  background-clip: padding-box;
  border: 1px solid;
  color: #768192;
  background-color: #fff;
  border-color: #d8dbe0;
  border-radius: 0.25rem;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}
</style>
<style>
.style-chooser .vs__open-indicator {
  fill: rgb(251 248 254);
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: -webkit-transform 150ms
    cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855),
    -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  -webkit-transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
  transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
}
.style-chooser .vs__clear {
  fill: rgb(251 248 254);
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  margin-right: 8px;
}
.style-chooser .vs__dropdown-toggle {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 0 0 4px 0;
  background: none;
  border: 1px solid #009efb;
  border-radius: 4px;
  white-space: normal;
  height: 36px;
}
.style-chooser .vs__selected {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #009efb;
  border: 1px solid #009efb;
  border-radius: 4px;
  color: #fff;
  line-height: 1.4;
  margin: 4px 2px 0px 2px;
  padding: 0 0.25em;
  z-index: 0;
}
.style-chooser .vs__single .vs__selected {
  background-color: #009efb;
  border-color: #009efb;
}
.custom-btn-blue {
  background: #009efb;
  border: 1px solid #009efb;
  color: #ffffff;
  border-radius: 4px;
}
.custom-btn-lgt {
  background: #7460ee;
  border: 1px solid #7460ee;
  color: #ffffff;
  width: 230px;
}
.btn-act {
  display: inline-block;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #7460ee;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.custom-btn-success {
  color: #fff;
  background-color: #2eb85c;
  border-color: #2eb85c;
  width: 230px;
}
.btn-primary {
  color: #fff;
  background-color: #7460ee;
  border-color: #7460ee;
}
.btn-primary:hover {
  color: #fff;
  background-color: #7460ee;
  border-color: #7460ee;
}
.no-scroll {
  overflow-x: inherit;
}
</style>
